import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "katex/dist/katex.min.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// ── Service Worker registration (production only) ─────────────────────────
// Strategy:
//   • skipWaiting() in sw.js ensures new SW activates immediately.
//   • clients.claim() in sw.js takes control of all open tabs at once.
//   • 'controllerchange' fires in THIS page when the new SW takes over.
//   • We reload the page so the browser fetches fresh JS/CSS bundles.
//   • We also poll /version.json as a safety net (see useVersionCheck hook).
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  // Guard: only reload when a PREVIOUS controller existed (avoids reload-loop on first install).
  let hadController = Boolean(navigator.serviceWorker.controller);

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (hadController) {
      // A new service worker just took control → load fresh bundles.
      console.log('[SW] New version detected — reloading for fresh content.');
      window.location.reload();
    }
    hadController = true;
  });

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('[SW] Registered:', registration.scope);

        // Listen for a new SW being installed.
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed') {
              console.log('[SW] New version installed — activation pending.');
              // sw.js calls skipWaiting() → controllerchange fires → reload above.
            }
          });
        });

        // Periodically tell the browser to check for a new sw.js.
        setInterval(() => registration.update(), 60_000);

        // Also check when the user returns to the tab (covers overnight sessions).
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') {
            registration.update();
          }
        });
      })
      .catch((err) => {
        console.warn('[SW] Registration failed:', err);
      });
  });
}

// Store the beforeinstallprompt event for use in the app
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  window.__pwaInstallPrompt = e;
  // Dispatch custom event so components can listen
  window.dispatchEvent(new CustomEvent('pwaInstallAvailable'));
});

window.addEventListener('appinstalled', () => {
  window.__pwaInstallPrompt = null;
  window.dispatchEvent(new CustomEvent('pwaInstalled'));
});
